import React from "react";
import { Modal } from "@mui/material";
import check from "../../assets/check.png";

export default function SuccessProfileModal({show}) {
  return (
    <>
      <div>
        {show && (
          <Modal
           open={show}
          >
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="success-profile-modal-wrapper" >
              <div className="p-lg-5 p-2 text-center">
                <img src={check} alt="" />
                <h3 className="mt-4">Profile Updated Successfully!</h3>
              </div>
            </div>
          </div>
          </Modal>
        )}
      </div>
    </>
  );
}
